import { Record } from 'immutable';
import { User, ApiUser } from './User';

export type ApiMessage = {
  id: number;
  sender: ApiUser;
  sent_at: string;
  body: string;
  is_read: boolean;
};

const MessageBase = Record({
  id: 0,
  sender: new User(),
  sentAt: "",
  body: "",
  isRead: false
});

export class Message extends MessageBase {
  constructor(apiMessage?: ApiMessage) {
    super({
      id: apiMessage?.id,
      sender: new User(apiMessage?.sender),
      sentAt: apiMessage?.sent_at,
      body: apiMessage?.body,
      isRead: apiMessage?.is_read
    })
  }

  get sentAtJst(): string {
    if (!this.sentAt) {
      return "";
    }
    const utc = new Date(this.sentAt);
    const offset = -1 * utc.getTimezoneOffset() / 60;
    const local = new Date(utc.getTime() + (offset * 3600000));
    return local.toLocaleString('ja-JP', {
      timeZone: 'Asia/Tokyo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
}
